module.exports = __webpack_public_path__ + "static/img/twjd-sdr4.5ba0cac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdr4.png
// module id = 869
// module chunks = 0